import React from "react";

const Search = ({ onSearchClick, ...restProps }) => (
  <div className="search">
    <div className="InputContainer__input--inline">
      <input type="text" {...restProps} />
      <button
        className="Search__button Search__button--search"
        onClick={() => onSearchClick()}
      ></button>
    </div>
  </div>
);

export default Search;
